import { CampaignPlannerContext } from '@/dashboards/CampaignPlanner/context/CampaignPlannerContext';
import { useContext } from 'use-context-selector';

export const useCampaignPlannerContext = () => {
    const context = useContext(CampaignPlannerContext);

    if (!context) {
        throw new Error(
            'useCampaignPlannerContext must be used within a CampaignPlannerContextProvider',
        );
    }

    return context;
};
